import Gleap from 'gleap'
import { DEV_MODE, GLEAP_API_KEY } from 'config'

export const initGleap = () => {
  if (!DEV_MODE && GLEAP_API_KEY) {
    Gleap.initialize(GLEAP_API_KEY)
  }
}
